import { useContext, useEffect, useState } from "react";
import { Prompt } from "react-router-dom";
import {
    useHistory,
    useParams,
    useLocation,
} from "react-router-dom";
import Field from "./Field";
import { firestore } from "./firebase";
import { UserContext } from "./providers/UserProvider";
import { toast } from "react-toastify";


export default function Artist() {
    const history = useHistory();
    const location = useLocation();

    const { user } = useContext(UserContext);

    const { id } = useParams();

    const [data, setData] = useState({});
    const [artist, setArtist] = useState(null);

    const [unsavedChanges, setUnsavedChanges] = useState(false);

    useEffect(() => JSON.stringify(data) !== JSON.stringify(artist?.data()) ? setUnsavedChanges(true) : setUnsavedChanges(false), [data, artist]);

    useEffect(() => firestore.collection('artists').doc(id).get().then(document => {
        setData(document.data());
        setArtist(document);
    }), [id]);

    const save = async () => {
        data.agent = user.uid;
        await firestore.collection('artists').doc(id).set(data, { merge: true });
        setUnsavedChanges(false);
        toast.success("Speichern erfolgreich", {theme: "dark"})
    };

    const writePermission = true;

    return <div>
        <Prompt message="Einige Änderungen wurden noch nicht gespeichert. Trotzdem fortfahren?" when={unsavedChanges} />
        <div className="bg-gray-500 flex flex-col md:flex-row gap-2 p-4 md:py-0 md:px-2">
            <button className="bg-blue-500 px-6 py-1 md:py-2 rounded md:rounded-b-none md:rounded-t md:mt-2 md:font-semibold text-white" onClick={save}>Änderungen speichern</button>
        </div>
        {
            id && artist ? <div className="p-3" key={artist.id}>
                <div className="font-bold">Metadaten</div>
                <div className="flex-col md:flex-row flex my-1">
                    <div className="w-64">ID:</div>
                    <div className="w-64">{id}</div>
                </div>
                <div className="flex-col md:flex-row flex my-1">
                    <div className="w-64">Erstellt:</div>
                    <div className="w-64">{artist?.data()?.created_timestamp?.toDate()?.toLocaleString('de-DE')}</div>
                </div>
                <div className="flex-col md:flex-row flex my-1">
                    <div className="w-64">Zuletzt bearbeitet von:</div>
                    <div className="w-64">{artist?.data()?.agent}</div>
                </div>
                {artist?.data()?.partner && <div className="flex-col md:flex-row flex my-1">
                    <div className="w-64">Erstellt mit Partner-Formular:</div>
                    <div className="w-64">{artist?.data()?.partner}</div>
                </div>}
                <div className="font-bold mt-3 pt-3 border-t-2">Daten</div>
                <Field name="Name" value={artist.data()?.name} onChange={(val) => setData({...data, ...{name: val}})} />
                <Field name="Label" value={data?.labels} type="array-location" onChange={(val) => setData({...data, ...{labels: val}})} />
                <Field name="Spotify ID" value={data?.spotify_identifier} onChange={(val) => setData({...data, ...{spotify_identifier: val}})} />
                <Field name="Soundcloud ID" value={data?.soundcloud_identifier} onChange={(val) => setData({...data, ...{soundcloud_identifier: val}})} />
                <Field name="Musikrichtungen" value={artist.data()?.genre} type="array-genre" onChange={(val) => setData({...data, ...{genre: val}})} />
                <Field name="Bild" value={data?.images ? data.images[0] : null} type="image" fileDirectory={`artist_images/${id}`} artistId={id} onChange={(val) => setData({...data, ...{images: [val]}})} />
                <button className="bg-blue-500 text-white rounded px-2 md:px-10 md:py-3 font-semibold" onClick={writePermission && save}>{writePermission ? 'Änderungen speichern' : 'Du hast hier keine Schreibberechtigung'}</button>
            </div> : <div className="p-3">
                Bitte warten...
            </div>
        }
    </div>;
}